import { render, staticRenderFns } from "./waterQuality.vue?vue&type=template&id=bef0e9c2&scoped=true&"
import script from "./waterQuality.vue?vue&type=script&lang=js&"
export * from "./waterQuality.vue?vue&type=script&lang=js&"
import style0 from "./waterQuality.vue?vue&type=style&index=0&id=bef0e9c2&scoped=true&lang=scss&"
import style1 from "./waterQuality.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0e9c2",
  null
  
)

export default component.exports